import axios from 'axios';
import config from 'config';
import store from '../store';
import { Effects, loop } from 'redux-loop';
import { finalize } from "actions/URLfinalizer";

import {
  FETCH_IMAGE,
  fetchImage,
  RECEIVE_IMAGE,
  receiveImage
} from 'actions/floorplan';

const initialState = {
  loading: false,
  uploadImageSuccessful: false,
  uploadImageFailed: false,
  images: null
};

function _fetchImage(id) {
  if (!id) {
    id = store.getState().myAccountReducer.user.companyid;
  }
  return axios.get(finalize(`${config.api.root}/node/image/${id}`))
    .then(receiveImage)
    .catch(fetchImage(id))
}

// Reducing function
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_IMAGE: {
      return loop(
        Object.assign({}, initialState),
        Effects.promise(_fetchImage, action.id)
      )
    }
    case RECEIVE_IMAGE: {
      return Object.assign({}, initialState, { images: action.data })
    }
    default: {
      return state;
    }

  }
}



// WEBPACK FOOTER //
// ./src/reducers/floorplan.js